import type { PropertyTypeReplacement } from "@/shared/utils/TypeUtils.ts";
import type {
  AvailabilityLevel,
  WeekDayAvailability,
} from "@/pages/human-resources/time-management/business/contract/WeekDayAvailability.ts";
import { availabilityLevelFromString } from "@/pages/human-resources/time-management/business/contract/WeekDayAvailability.ts";

export type WeekDayAvailabilityOut = PropertyTypeReplacement<
  WeekDayAvailability,
  AvailabilityLevel,
  string
>;

export function mapToWeekDayAvailability(
  wdao: WeekDayAvailabilityOut,
): WeekDayAvailability {
  return {
    ...wdao,
    available: availabilityLevelFromString(wdao.available),
  };
}
